var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center",style:(`background-color:${_vm.bgColor}`)},[_c('div',{staticClass:"w-11/12 lg:w-9/12"},[_c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 gap-16 py-10",style:(`background-color:${_vm.bgColor}`)},[_vm._t("story"),_vm._t("avatar")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }